import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';

import { Store } from '@ngrx/store';
import * as fromRootStore from '../../../reducers';

import { CommonService, PartyNameService } from '../../../services/index';

@Component({
    selector: 'add-edit-partyName-window',
    templateUrl: './addEditPartyName.component.html'
})
export class AddEditPartyNameComponent implements OnInit {

    public title: string;
    public mode: string;
    public list: any[] = [];
    public partyNamedata: any[] = [];

    isLoading: boolean = false;
    @Output() partyNameLoadEvent = new EventEmitter();

    constructor(public store: Store<fromRootStore.State>, private partyNameService: PartyNameService, public snackBar: MdSnackBar, public bsModalRef: BsModalRef, public toasterService: ToasterService, private commonService: CommonService) {
  
    }

    ngOnInit(): void {
        setTimeout(() => {
            $('#party_name').focus();
        }, 100);
    }

    onSavePartyName(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        
        let that = this;
        this.isLoading = true;
        this.partyNameService
            .addUpdatePartyName(this.partyNamedata)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    that.partyNameLoadEvent.emit();
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: res.message
                    };

                    that.toasterService.pop(toast);
                }

            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/partyName/addEditPartyName.component.ts